<div class="card border-reset">
  <div class="card-header padding-all text-center">
    <h4 class="margin-b-s"><b>{{'advertising.dialog.delete.title' | translate}}</b></h4>
  </div>
  <div class="card-body">
    <div class="row margin-t">
      <div class="columns small-12 medium-6 small-centered">
        <div class="button-group expanded">
          <button class="button border-radius-default light-gray"
                  (click)="close()">
            {{'news.event.delete-cancel' | translate }}
          </button>
          <button class="button border-radius-default alert"
                  (click)="delete()">
            {{'news.event.delete-validation' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

